import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import DifferenceOutlinedIcon from '@mui/icons-material/DifferenceOutlined';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import CastForEducationOutlinedIcon from '@mui/icons-material/CastForEducationOutlined';

import FollowTheSignsOutlinedIcon from '@mui/icons-material/FollowTheSignsOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import AcUnitOutlinedIcon from '@mui/icons-material/AcUnitOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import AutoModeOutlinedIcon from '@mui/icons-material/AutoModeOutlined';
// Define icon mapping based on category
const getIcon = (category) => {
  const iconStyle = {
    width: 24,
    height: 24,
    // verticalAlign: 'middle',
    fill: '#101316ff', // MUI primary blue
    marginRight: 8,
  };

  switch (category.toLowerCase()) {
    case 'user management':
      return <GroupAddOutlinedIcon style={iconStyle} />;
    case 'reports':
      return <AssessmentOutlinedIcon style={iconStyle} />;
    case 'account admin':
      return <AdminPanelSettingsOutlinedIcon style={iconStyle} />;
    case 'statistics':
      return <AnalyticsOutlinedIcon style={iconStyle} />;
    case 'content management':
      return <DifferenceOutlinedIcon style={iconStyle} />;
    case 'lab creation':
      return <AddBoxOutlinedIcon style={iconStyle} />;
    case 'inventory management':
      return <Inventory2OutlinedIcon style={iconStyle} />;
    case 'file management services':
      return <BackupOutlinedIcon style={iconStyle} />;
    case 'instructer access':
      return <CastForEducationOutlinedIcon style={iconStyle} />;
    case 'signup requests':
      return <FollowTheSignsOutlinedIcon style={iconStyle} />;
    case 'ip information':
      return <DnsOutlinedIcon style={iconStyle} />;
    case 'wizard templates':
      return <AcUnitOutlinedIcon style={iconStyle} />;
    case 'archived clusters':
      return <ArchiveOutlinedIcon style={iconStyle} />;
    case 'automation scripts':
      return <AutoModeOutlinedIcon style={iconStyle} />;

    // Add more cases for other categories as needed'
    default:
      return null;
  }
};

const useStyles = makeStyles((theme) => ({
  card: {
    margin: theme.spacing(1),
    borderRadius: 8,
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'scale(1.1)',
    },
    // display:'flex',
    // justifyContent:'center',
  },
  title: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  description: {
    color: '#202124',
    fontSize: '0.9rem',
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  button: {
  textAlign:'center',
  width: 'fit-content',        // ✅ Width based on content
  minWidth: 'auto',            // Remove default MUI min-width
  padding: '6px 16px',         // Optional: reduce padding for tighter fit
  margin: '8px auto',          // Center it with margin
  background: '#00AEEF',
  color: 'white',
  '&:hover': {
    background: '#0B1B3D',
  },
  '&:focus': {
    minWidth: 'auto',          // Prevent MUI from adding min-width on focus
  },
},
}));

const DynamicCard = ({ item }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <div style={{ display: 'flex',justifyContent:'center'}}>
          {getIcon(item.category)}
          <Typography variant="h6" className={classes.title}>
            {item.title}
          </Typography>
        </div>
        <Typography variant="body2" className={classes.description}>
          {item.description}
        </Typography>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            variant="contained"
            className={classes.button}
            onClick={() => {
              window.location.href = item.path;
            }}
          >
            {`Go to ${item.category.toLowerCase()}`}
          </Button>
        </div>
      </CardContent>  
    </Card>
  );
};

export default DynamicCard;